import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { handleError } from './utils/errorHandler'

// Import global styles
import './styles/index.css'

// Global error handler for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  // Only handle errors that are APIErrors or network errors
  // Other errors should be logged but not shown to users
  const error = event.reason
  if (error && (error.name === 'APIError' || error.message?.includes('Network') || error.message?.includes('fetch'))) {
    handleError(error, store)
    event.preventDefault() // Prevent default console error
  }
})

createApp(App).use(store).use(router).mount('#app')
